'use client';

import RequiredConsent from '@/features/term/components/RequiredConsent/RequiredConsent';
import { type PendingReconsentTerm, isReconsentSuppressed } from '@monorepo/common';
import { useEffect, useState } from 'react';

export type ReconsentOnVisitProps = {
  /**
   * サーバー側で取得済みのユーザーID。抑制をユーザーごとに判定するために使う。
   * 未ログイン等で特定できない場合は undefined（抑制を効かせず表示する）。
   */
  userId: number | undefined;
  /** サーバー側で取得済みの pending 文書。空なら何も描画しない */
  terms: PendingReconsentTerm[];
};

/**
 * 表示層①（訪問時）。
 *
 * TOPページ・くじ詳細ページにのみ設置する（共通レイアウトには置かない）。
 * キャンセル後24時間は抑制し、24時間経過後に再表示する。
 * 抑制はユーザーごと・規約タイプごとに持つため、同一ブラウザーでアカウントを
 * 切り替えても前のアカウントの抑制は引き継がれず、ある規約をキャンセルしても
 * 他に同意が必要な規約は引き続き表示する。
 * 抑制判定は localStorage を見るためマウント後に行う（サーバー描画とのズレを避ける）。
 */
function ReconsentOnVisit({ userId, terms }: ReconsentOnVisitProps) {
  const [visibleTerms, setVisibleTerms] = useState<PendingReconsentTerm[]>([]);

  useEffect(() => {
    if (terms.length === 0) return;
    const notSuppressed = terms.filter((document) => !isReconsentSuppressed(userId, document.category));
    if (notSuppressed.length === 0) return;
    setVisibleTerms(notSuppressed);
  }, [userId, terms]);

  if (visibleTerms.length === 0) return null;

  // 閉じた後は再描画しない（同一ページ内での再表示はしない）
  return <RequiredConsent userId={userId} terms={visibleTerms} onFinished={() => setVisibleTerms([])} />;
}

export default ReconsentOnVisit;
